/**
 * Model that represents a single UserPreference. Note that the similarly-named model UserPreferences actually represents UserProfileSettings
 */
import Backbone from 'backbone';

var UserPreference = Backbone.Model.extend({
    urlRoot: function() {
        return '/userpreference-service/';
    },

    backend: 'gcapi',
    idAttribute: 'key',

    initialize: function(args) {},

    getValue: function() {
        return this.get('value');
    },

    setValue: function(value) {
        return this.set('value', value);
    },

    equalsIgnoreCase: function(value) {
        if (this.get('value') !== undefined) {
            return this.get('value').toLowerCase() === value.toLowerCase();
        }
    }
});

export default UserPreference;
